export default __webpack_public_path__ + "static/media/mar_logo_banner.d66d6df4.png";